import { createFileRoute, Link } from "@tanstack/react-router";
import { PageHeader } from "@/components/site/PageHeader";
import { SHARE_IMAGES } from "@/lib/share-images";

export const Route = createFileRoute("/bundles")({
  head: () => ({
    meta: [
      { title: "Bundles — Glow Long Golf" },
      { name: "description", content: "Multi-pack bundles of Glow Long golf balls. The 12-pack is the best per-ball value; the Event Pack is built for tournaments and night-golf outings." },
      { property: "og:title", content: "Bundles — Glow Long Golf" },
      { property: "og:description", content: "Multi-pack bundles of Glow Long golf balls. The 12-pack is the best per-ball value; the Event Pack is built for tournaments." },
      { property: "og:url", content: "https://glowlonggolf.com/bundles" },
      { property: "og:image", content: SHARE_IMAGES.flatLayGrid },
      { name: "twitter:image", content: SHARE_IMAGES.flatLayGrid },
    ],
    links: [{ rel: "canonical", href: "https://glowlonggolf.com/bundles" }],
  }),

  component: () => (
    <>
      <PageHeader eyebrow="Bundles" title="Buy more, save more" lead="The 12-pack is the best per-ball value. The Event Pack is built for tournaments." />
      <section className="mx-auto max-w-3xl px-4 pb-16 text-center sm:px-6 lg:px-8">
        <Link to="/shop" className="inline-flex rounded-full bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground shadow-glow hover:opacity-90">See all packs</Link>
      </section>
    </>
  ),
});
